import React from 'react';
import MainLayout from './MainLayout';

const SimpleLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <MainLayout className="p-4 bg-white border-t border-gray-200">
      {children}
    </MainLayout>
  );
};

export default SimpleLayout;
